module.exports = __webpack_public_path__ + "img/tagging-image-yes.01bdf27d.png";